import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const AppleOrgConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.APPLE}
    flow="orgConnect"
    redirectPath={paths.auth.appleOrgConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccess"
  />
)
